/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".NumberTextField{display:table}.NumberTextField>*{display:table-cell}.NumberTextField>.NumberTextField-textField{width:100%}.NumberTextField>.NumberTextField-restoreButton{vertical-align:top;padding-top:29px}"}]);
/* tslint:enable */